import { type MissingCredentialType } from "@src/appV2/redesign/Documents/types";
import { Pill } from "@src/appV2/redesign/system/ui-components";

interface PlacementMissingCredentialPillProps {
  missingCredentialType: MissingCredentialType;
}

export function PlacementMissingCredentialPill(props: PlacementMissingCredentialPillProps) {
  const { missingCredentialType } = props;

  return (
    <Pill
      variant="outlined"
      iconType="locked-filled"
      size="small"
      label={
        missingCredentialType === "BASE_CREDENTIAL"
          ? "State qual. missing"
          : "Qualification missing"
      }
      backgroundColor={(theme) => theme.palette.background.tertiary}
      color={(theme) => theme.palette.text.secondary}
    />
  );
}
